import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type {
  CollectionsResponse,
  Collection,
  Item,
  SearchResponse,
  SearchPayload
} from 'types/stac';
// import { STAC } from 'stac-js';

const pgStacApiUrl = process.env.REACT_APP_PGSTAC_API;

// Define a service using a base URL and expected endpoints
export const pgStacApi = createApi({
  reducerPath: 'pgStacApi',
  baseQuery: fetchBaseQuery({ baseUrl: pgStacApiUrl }),
  endpoints: (builder) => ({
    getCollectionsResponse: builder.query<CollectionsResponse, void>({
      query: () => `collections`
    }),
    getCollectionByCollectionID: builder.query<Collection, string>({
      query: (collectionID) => `collections/${collectionID}`
    }),
    getCollectionQueryablesByCollectionID: builder.query<
      Record<string, string>,
      any
    >({
      query: (collectionID) => `collections/${collectionID}/queryables`
    }),
    getCollectionItemsByCollectionID: builder.query<
      SearchResponse,
      {
        collectionID: string;
        page: number;
        numResultsPerPage: number;
      }
    >({
      query: ({ collectionID, page = 1, numResultsPerPage = 20 }) =>
        `collections/${collectionID}/items?page=${page}&limit=${numResultsPerPage}`
    }),
    getItemByCollectionIDAndItemID: builder.query<
      Item,
      { collectionID: string; itemID: string }
    >({
      query: ({ collectionID, itemID }) =>
        `collections/${collectionID}/items/${itemID}`
    }),
    getItemDownloadByCollectionIDAndItemID: builder.query<
      Item,
      { collectionID: string; itemID: string }
    >({
      query: ({ collectionID, itemID }) =>
        `collections/${collectionID}/items/${itemID}/download`
    }),
    searchItems: builder.query<SearchResponse, SearchPayload>({
      query: (searchFilters) => ({
        url: 'search',
        method: 'POST',
        body: searchFilters
      })
    })
  })
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetCollectionsResponseQuery,
  useGetCollectionQueryablesByCollectionIDQuery,
  useGetCollectionItemsByCollectionIDQuery,
  useGetItemByCollectionIDAndItemIDQuery,
  useGetItemDownloadByCollectionIDAndItemIDQuery,
  useSearchItemsQuery,
  useLazySearchItemsQuery
} = pgStacApi;
